import Component from '../abstracts/Component';
import ScrollMagic from 'scrollmagic';
import vex from 'vex-js';
import { removeAlgoliaAttributes } from '../utils/algoliaTrackings';

export default class PdpMainComponent extends Component {
  get SELECTORS() {
    return {
      header: '[data-js-component="HeaderComponent"]',
      wrapper: '[data-wrapper]',
      infoContainer: '[data-product-info]',
      skuInfo: '[data-info-container]',
      scrollSection: '[data-scroll-section]',
      completeLook: '[data-js-component="CompleteLookComponent"]',
      images: '[data-images]',
      image: '[data-image]',
      sizeGuideTrigger: "[data-js-size-guide]"
    };
  }

  constructor(compEl) {
    super(compEl);
    this.infoContainer = this.$component.querySelector(this.SELECTORS.infoContainer);
    this.wrapper = this.$component.querySelector(this.SELECTORS.wrapper);
    this.skuInfo = this.$component.querySelector(this.SELECTORS.skuInfo);

    this.completeLook = this.$component.querySelector(this.SELECTORS.completeLook);
    this.completeLookOffsetHeight = this.completeLook ? this.completeLook.offsetHeight : 0;

    this.imagesColumn = this.$component.querySelector(this.SELECTORS.images);
    this.lastImages = this.$component.querySelectorAll(this.SELECTORS.image);
    this.lastImage = this.lastImages[this.lastImages.length - 1];
    this.lastImageOffsetHeight = this.completeLook ? this.lastImage.offsetHeight : 0;

    this.sizeGuideTrigger = this.$component.querySelector(this.SELECTORS.sizeGuideTrigger);

    this.offset = 50;
    this.scrollOffset = 0;

    this.headerHeight = document.querySelector( this.SELECTORS.header).offsetHeight;
  }

  // handle size guide open //
  handleSizeGuide() {
    const self = this;
    if (this.sizeGuideTrigger) {
      this.sizeGuideTrigger.addEventListener("click", (event) => {
        event.preventDefault();
        this.sizeGuideTrigger.setAttribute('disabled', '');
        fetch(this.sizeGuideTrigger.href)
          .then(response => response.text())
          .then(text => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "text/html");
            const sizeGuide = doc.querySelector('[data-ajax-chunk]');
            vex.open({
              unsafeContent: sizeGuide,
              closeClassName: 'icon-close',
              className: 'size-guide',
              showCloseButton: true,
              afterOpen: function () {
                this.closeEl.classList.remove('vex-close');
                self.importComponents("CollapseComponent")
                  .then(({default: module}) => {
                    const component = new module(sizeGuide);
                    component.render();
                  })
                  .catch(error => {
                    console.error("Failed to load the component", error.stack);
                  });
              },
              afterClose: function () {
                self.sizeGuideTrigger.removeAttribute('disabled');
              }
            });
          })
          .catch(error => console.error(error));
      });
    }
  }

  readDOM() {
    return {
      infoSection: this.$component.querySelector(this.SELECTORS.scrollSection)
    };
  }

  setInfoSectionSticky() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      const header = document.querySelector('[data-js-component="HeaderComponent"]');
      if (header) {
        const height = header.offsetHeight;
        this.dom.infoSection.style.top = height + "px";
      } else {
        this.dom.infoSection.style.top = '0';
      }
    }
  }

  scrollInfoSection() {
    if (window.matchMedia('(min-width: 768px)').matches) {
      let previousScrollPosition = 0;
      window.addEventListener("scroll", () => {
        const scrollPosition = window.pageYOffset;
        if (scrollPosition > previousScrollPosition) {
          //scrolling down
          this.dom.infoSection.scroll({
            top: this.dom.infoSection.offsetHeight,
            behavior: "smooth",
          });
        } else {
          //scrolling up
          this.dom.infoSection.scroll({
            top: -this.dom.infoSection.offsetHeight,
            behavior: "smooth",
          });
        }
        previousScrollPosition = scrollPosition;
      });
    }
  }


  importComponents(componentName) {
    return import(`../components/${componentName}`);
  }

  bindEvents() {
    this.handleSizeGuide();
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.setInfoSectionSticky();
    this.scrollInfoSection();
    this.bindEvents();
    // If algolia params are stored remove them
    removeAlgoliaAttributes();
  }
}
